import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Service, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {GoogleService} from './google-service';
import {ProjectProductType} from "../enums/project-product-type";
import {BrandID} from "../enums/brand-id";
import {OrgunitXProjectProductType} from "../organization/organization-brands/orgunit-x-projectproducttype";

@Service()
export class OrganizationProjectProductTypeService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private urlBase = environment.serviceUrl;

  public getByOrgUnitId(orgUnitId: string): Observable<OrgunitXProjectProductType[]> {
    let url = this.urlBase + 'orgunitprojectproducttypes/' + orgUnitId;
    return this.http.get<OrgunitXProjectProductType[]>(url, {headers: this.getHeaders()});
  }

  public getOrgUnitXProjectProductType(orgUnitId: string, projectProductType: ProjectProductType, brandID: BrandID): Observable<OrgunitXProjectProductType> {
    let url = this.urlBase + 'orgunitprojectproducttypes/' + orgUnitId + '/' + projectProductType + '/' + brandID;
    return this.http.get<OrgunitXProjectProductType>(url, {headers: this.getHeaders()});
  }

  public delete(orgUnitId: string, projectProductType: ProjectProductType, brandID: BrandID): void {
    let url = this.urlBase + 'orgunitprojectproducttypes/' + orgUnitId + '/' + projectProductType + '/' + brandID;
    this.http.delete(url, {headers: this.getHeaders()});
  }

  public deleteByOrgUnitId(orgUnitId: string): Observable<string> {
    let url = this.urlBase + 'orgunitprojectproducttypes/' + orgUnitId;
    return this.http.delete(url, {headers: this.getHeaders(), responseType: 'text'});
  }

  public insert(orgUnitId: string, projectProductType: ProjectProductType, brandID: BrandID): Observable<string> {
    let url = this.urlBase + 'orgunitprojectproducttypes/' + orgUnitId + '/' + projectProductType + '/' + brandID;
    return this.http.put(url, {}, {headers: this.getHeaders(), responseType: 'text'});
  }

  private getHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }


}

